'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const PageContext = /*#__PURE__*/ React.createContext(undefined);
const PageSetter = /*#__PURE__*/ React.createContext(undefined);
export function PageProvider({ children, value: defaultPage }) {
    const [page, setPage] = React.useState(defaultPage);
    const pageSetter = React.useCallback((value)=>{
        setPage(value);
    }, []);
    return /*#__PURE__*/ _jsx(PageContext, {
        value: page,
        children: /*#__PURE__*/ _jsx(PageSetter, {
            value: pageSetter,
            children: children
        })
    });
}
export default function usePage() {
    const context = React.use(PageContext);
    if (context === undefined) {
        throw new Error('usePage must be used within a PageProvider');
    }
    return context;
}
export function useSetPage() {
    const context = React.use(PageSetter);
    if (context === undefined) {
        throw new Error('useSetPage must be used within a PageProvider');
    }
    return context;
}
export function usePageAtom() {
    return [
        usePage(),
        useSetPage()
    ];
}

//# sourceMappingURL=pageAtom.js.map